import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { ModeContact } from '../models/options/modeContacts/modeContact';

const resource = 'ModeContacts'

export default class ModeContactsRessources {
  public async paginatedList(typeInterventionId: string, pagenumber?: number, pagesize?: number, search?: string, actifOnly?: boolean) : Promise<PaginatedList<ModeContact>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 
    if (typeInterventionId && typeInterventionId.length) params.append('TypeInterventionId', typeInterventionId?.toString());

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
